import React from "react";

import { Helmet } from "react-helmet";

import { StopList } from "features/StopList";
import { MenuScopeFromRouteProvider } from "shared/context/MenuScopeContext";
import { PageTitle } from "shared/ui";

const TITLE = "Стоп-лист";

// Тонкая обёртка над фичей: ставит chrome страницы и отдаёт всё остальное features/StopList.
const StopListPage = () => {
    return (
        <>
            <PageTitle>{TITLE}</PageTitle>
            <Helmet title={TITLE} />
            <MenuScopeFromRouteProvider>
                <StopList />
            </MenuScopeFromRouteProvider>
        </>
    );
};

export default StopListPage;
